import shift4Logo from '../../../assets/shift4Logo.svg';
import styles from './PreAuthenticationDetails.module.scss';

interface IPreAuthFooterProps {
	defaultTipPercentageValue: number | boolean | undefined;
}

const PreAuthFooter: React.FC<IPreAuthFooterProps> = ({ defaultTipPercentageValue }) => {
	return (
		<div className={styles.preAuthFooter} id="preAuthFooter">
			<p className={styles.subText}>
				By clicking continue you agree to use this payment method to pay your tab. If you don’t pay your tab, it
				will be paid automatically{' '}
				{ defaultTipPercentageValue ? `(including a ${defaultTipPercentageValue}% tip) ` : '' } after 2 hours of
				inactivity.
			</p>
			<div className={styles.logoContainer}>
				<img src={shift4Logo} alt="shift4 logo" />
			</div>
		</div>
	);
};

export default PreAuthFooter;
